import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router';
import './index.css';
import Home from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import NewLink from './pages/NewLink';
import LinkDetail from './pages/LinkDetail';
import Domains from './pages/Domains';
import AddDomain from './pages/AddDomain';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import Members from './pages/Members';
import AcceptInvite from './pages/AcceptInvite';
import Pages from './pages/Pages';
import NewPage from './pages/NewPage';
import PageEditor from './pages/PageEditor';
import AdminBotResearch from './pages/AdminBotResearch';
import AdminClients from './pages/AdminClients';
import AdminPlatformPixel from './pages/AdminPlatformPixel';
import SettingsPixel from './pages/SettingsPixel';
import NotFound from './pages/NotFound';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/app" element={<Dashboard />} />
        {/* /app/links used to be a separate page; we folded it into the
            Overview (/app) so customers have ONE place to see and manage
            links. Keep the route resolving for any bookmarks — same
            page renders. */}
        <Route path="/app/links" element={<Dashboard />} />
        <Route path="/app/links/new" element={<NewLink />} />
        <Route path="/app/links/:id" element={<LinkDetail />} />
        <Route path="/app/domains" element={<Domains />} />
        <Route path="/app/domains/add" element={<AddDomain />} />
        <Route path="/app/pages" element={<Pages />} />
        <Route path="/app/pages/new" element={<NewPage />} />
        <Route path="/app/pages/:id" element={<PageEditor />} />
        {/* The cross-link Variations overview was removed 2026-05-18 —
            it was just a list of links pointing back at the link
            editor, redundant with the Overview page. Variations are
            now per-link only, edited in context. Legacy bookmarks
            land back on the Overview. */}
        <Route path="/app/rules" element={<Dashboard />} />
        <Route path="/app/variations" element={<Dashboard />} />
        <Route path="/app/analytics" element={<Analytics />} />
        <Route path="/app/settings" element={<Settings />} />
        <Route path="/app/settings/members" element={<Members />} />
        <Route path="/app/settings/pixel" element={<SettingsPixel />} />
        <Route path="/app/admin" element={<AdminClients />} />
        <Route path="/app/admin/clients" element={<AdminClients />} />
        <Route path="/app/admin/bot-research" element={<AdminBotResearch />} />
        <Route path="/app/admin/platform-pixel" element={<AdminPlatformPixel />} />
        <Route path="/accept-invite/:id" element={<AcceptInvite />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        {/* Catch-all 404 — anything not matched above. Renders a proper
            page instead of a blank screen, which is what unrouted paths
            (e.g. /app/admin/ before this catch-all existed) used to show. */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
